import styled from "styled-components"

export const Page = styled.div`
  width: 100vw;
  height: calc(100vh - 5rem);
  display: flex;
  align-items: center;
  justify-content: center;
`
